import { useContext, useEffect, useState } from 'react';
import { useOutletContext, useParams } from 'react-router';
import { useTranslation } from 'react-i18next';

import { PlaceOutletContextType } from "../home/PlacesHome";
import { Lead, NotificationType } from 'shared/topchef.types';
import placesApi from 'shared/topchef-api-places';
import Loading from 'pages/shared/loading/Loading'
import { NotificationContext } from 'shared/NotificationContext'
import LeadContent from 'pages/shared/lead-content/LeadContent'
import { useErrorBoundary } from 'react-error-boundary'

const SharedLeadDetails = () => {

  const { t } = useTranslation();
  const [loggedInPlace] = useOutletContext<PlaceOutletContextType>();

  const notificationContext = useContext(NotificationContext);
  const { triggerNotification } = notificationContext;

  const params = useParams();
  const leadId: string = params.leadId || '';

  const [isReady, setReady] = useState<boolean>(false);
  const [currentLead, setCurrentLead] = useState<Lead | null>(null);

  const { showBoundary } = useErrorBoundary();

  useEffect(() => { // eslint-disable-line react-hooks/exhaustive-deps

    async function loadLead() {
      try {
        const lead: Lead = await placesApi.loadSharedLead(loggedInPlace!.id, leadId);
        setCurrentLead(lead);
        setReady(true);
      } catch (error: any) { 
        const newError = new Error(t('apiErrors.loadLeadDetails', { details: error.message }) as string);
        triggerNotification({type: NotificationType.error, message : newError.message});
        return showBoundary(newError);
      } 
    }

    if (isReady) {
      return;
    }

    loadLead();

  }, [currentLead, isReady, leadId, loggedInPlace, showBoundary, triggerNotification]); // eslint-disable-line react-hooks/exhaustive-deps


  if (!isReady) {
    return (
      <Loading />
    );
  }

  return (
    <div className="container page-briefs-single-details p-2 col-md-6 overflow-auto">
      <div id="lead_sidebar" className="d-flex">
        <ul className="nav nav-pills flex-column mb-auto">
          <li className="nav-item"> <a href="/places/share-a-lead" type="button" className="btn btn-outline-primary nav-link add-brief-link">{t('common.addBrief')}</a></li>
        </ul>
      </div>
     
      <LeadContent lead={currentLead!} />

    </div>
  );

}


export default SharedLeadDetails;
